import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";
import { Note } from "../note-models";
import { JobsService } from "../../jobs-and-tasks/jobs.service";
import { HotToastService } from "@ngneat/hot-toast";

import { CommonModule, NgIf } from "@angular/common";
import { Editor, EditorModule } from "primeng/editor";
import { FormsModule } from "@angular/forms";

@Component({
    selector: "app-new-note-modal",
    templateUrl: "./new-note-modal.component.html",
    styleUrls: ["./new-note-modal.component.scss"],
    imports: [CommonModule, FormsModule, NgIf, EditorModule]
})
export class NewNoteModalComponent implements OnInit, AfterViewInit {
  title: string;
  content: string;
  clientInformation: string;

  @ViewChild("inputTitle", { static: true }) inputTitle: ElementRef;
  @ViewChild("rte") public rte: Editor;

  public onClose: Subject<boolean | Note>;

  public constructor(
    public bsModalRef: BsModalRef,
    public jobsService: JobsService,
    private toastr: HotToastService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.onClose = new Subject();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.inputTitle.nativeElement.focus();
    }, 0);
  }

  onTitleEnterKey(event: KeyboardEvent) {
    event.preventDefault();
    this.rte.getQuill().focus();
  }

  confirm(): void {
    if (!this.title) {
      this.toastr.info("To create a new note, please provide a title");
      return;
    }
    this.bsModalRef.hide();
    this.onClose.next({ title: this.title, content: this.content });
  }

  cancel(): void {
    this.bsModalRef.hide();
    this.onClose.next(false);
  }
}
